import * as React from 'preact/compat'

import SVG from '#components/SVG'
import type { SearchItemProps } from '#components/Search/SearchPanel'

import styles from '#css/search-panel.pcss.json'
import commonCss from '#css/v9/common.pcss.json'

// noinspection ES6UnusedImports

export default ({ item }: SearchItemProps) => {
  return <>
    <a href={item.url} className={styles['faq-card']} data-material-card={true}>
      <h3 className={styles['faq-card__title']} data-material-card-title={true}>{item.title}</h3>
      <span className={styles['faq-card__section']}>{item.sectionName}</span>
      <div className={styles['faq-card__text']}>{item.text}</div>
      <div className={styles['faq-card__info-row']}>
        <div className={styles['faq-card__info-row__left']}>
          <span className={styles['faq-card__info']}>{item.date}</span>
          <span className={styles['faq-card__info']}>
            <SVG i='sg-new/eye' adaptive/>
            {item.views}
          </span>
          {item.status === 'solved' && <span className={styles['faq-card__info']} style='color: var(--green)'>
            <SVG i="sg-new/check" adaptive/>
            Решено
          </span>}
          {item.status === 'closed' && <span className={styles['faq-card__info']}>
            <SVG i="sg-new/cross" adaptive/>
            Вопрос закрыт
          </span>}
        </div>
        <span className={styles['faq-card__comments']}>
          <SVG i="sg-new/comments" adaptive/>
          {item.comments}
        </span>
      </div>
    </a>
    <hr className={commonCss['separator']}/>
  </>
}
